import Check from "../Icons/solid/CheckIcon"
import classNames from "../../utils/classNames"

export default function StepsLineWithCircles({
  steps
}) {

  if (!steps.length) return '';

  return (
    <nav aria-label="Progress" className="flex px-8 md:px-0 justify-center items-center max-w-full">
      <ol className="flex items-center relative w-full">
        {steps.map((step, stepIdx) => (
          <li key={step.name} className={classNames(stepIdx !== steps.length - 1 ? stepIdx === 0 ? 'flex-grow' : "flex-grow" : '', 'flex flex-row justify-center items-center')}>
            <div className='justify-self-start'>
              {step.status === 'complete' &&
                <div className="relative  w-8 h-8 flex items-center justify-center bg-primary rounded-full hover:bg-primary">
                  <Check styles="w-5 h-5"/>
                  <span className="sr-only">{step.name}</span>
                </div>
              }
              {step.status === 'current' &&
                <div
                  className="relative  w-8 h-8 flex items-center justify-center bg-white border-2 border-primary rounded-full"
                  aria-current="step"
                >
                  <span className="h-2.5 w-2.5 bg-primary rounded-full" aria-hidden="true" />
                  <div className="absolute flex justify-center w-48 transform translate-y-5 top-0">
                    <div className="relative bg-primary shadow-lg px-2 py-1 rounded mt-4">
                      <svg className="absolute top-0 -mt-1 w-full right-0 left-0" width="16px" height="8px" viewBox="0 0 16 8" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g id="Progress-Bars" transform="translate(-322.000000, -198.000000)" fill="#4c51bf">
                            <g id="Group-4" transform="translate(310.000000, 198.000000)">
                                <polygon fill="#006bb7" id="Triangle" points="20 0 28 8 12 8" />
                            </g>
                        </g>
                      </svg>
                      <p className="text-white text-xs font-bold text-center">{step.name}</p>
                    </div>
                  </div>
                </div>
              }
              {step.status === 'upcoming' &&
              <div
                className="group relative w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full hover:border-gray-400"
              >
                <span
                  className="h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300"
                  aria-hidden="true"
                />
                <span className="sr-only">{step.name}</span>
              </div>
              }
            </div>
            {stepIdx !== steps.length - 1 &&    
            <div className='flex-grow' aria-hidden="true">
              <div className={step.status === 'complete' ? "h-0.5 w-full bg-primary" : "h-0.5 w-full bg-gray-300"}/>
            </div>
            }
          </li>
        ))}
      </ol>
    </nav>
  )
}
